import { Search, Wallet, FileText, Users } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";
import { SectionTitle } from "./ui";

const CARDS = [
  [Search, "Conocer alternativas", "Te mostramos opciones de planes que se ajusten a tu caso, para que no elijas a ciegas."],
  [Wallet, "Cuidar tu presupuesto", "Buscamos alternativas acordes a lo que puedes y quieres pagar cada mes."],
  [FileText, "Entender coberturas y copagos", "Te explicamos en palabras simples qué cubre un plan y cuánto pagarías tú."],
  [Users, "Pensar en tu familia", "Consideramos a tus cargas y lo que tu familia necesita hoy y más adelante."],
];

export const Help = () => (
  <section id="ayuda" data-testid="help-section" className="bg-[#F4F7F9] py-16 sm:py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal><SectionTitle title="¿Cómo podemos ayudarte?" /></Reveal>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
        {CARDS.map(([I, t, d], i) => (
          <Reveal key={t} delay={i * 0.06} className="h-full">
            <article className="h-full rounded-2xl border border-[#E3EAEF] bg-white p-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(11,60,93,.3)]" data-testid={`help-card-${i}`}>
              <I className="h-8 w-8 text-[#13766C]" aria-hidden="true" />
              <h3 className="mt-5 text-[21px] font-bold leading-snug text-[#0B3C5D]">{t}</h3>
              <p className="mt-2 text-[17px] leading-relaxed text-[#4A5864]">{d}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
